import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  input,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChip, MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { NoTranslateMaterialSymbolsDirective } from '../../../../../shared/directives/noTranslateMaterialSymbols.directive';

@Component({
  selector: 'app-chips-container',
  imports: [
    MatChipsModule,
    NoTranslateMaterialSymbolsDirective,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './chips-container.component.html',
  styleUrl: './chips-container.component.scss',
})
export class ChipsContainerComponent implements AfterViewInit {
  @ViewChild('leftButton') leftButton: ElementRef<HTMLButtonElement>;
  @ViewChild('rightButton') rightButton: ElementRef<HTMLButtonElement>;
  @ViewChild('container') container: ElementRef<HTMLDivElement>;

  width = input('100%');

  @HostListener('window:resize')
  onResize() {
    this.checkScrollButtons();
  }

  @HostBinding('style.width')
  get getWidth(): string {
    // Si es número, añade 'px', de lo contrario, usa el string directamente
    return typeof this.width() === 'number'
      ? `${this.width()}px`
      : this.width();
  }

  ngAfterViewInit() {
    // Verificación inicial
    setTimeout(() => this.checkScrollButtons(), 0);
  }

  scrollLeft() {
    if (this.container) {
      this.container.nativeElement.scrollBy({ left: -100, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(), 100);
    }
  }

  scrollRight() {
    if (this.container) {
      this.container.nativeElement.scrollBy({ left: 100, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(), 100);
    }
  }

  checkScrollButtons() {
    if (!this.container || !this.leftButton || !this.rightButton) return;

    const { scrollLeft, scrollWidth, clientWidth } =
      this.container.nativeElement;

    // Mostrar/ocultar botón izquierdo
    const showLeftButton = scrollLeft > 0;
    this.leftButton.nativeElement.style.display = showLeftButton
      ? 'flex'
      : 'none';

    // Mostrar/ocultar botón derecho
    const hasMoreToScroll = Math.ceil(scrollLeft + clientWidth) < scrollWidth;
    this.rightButton.nativeElement.style.display = hasMoreToScroll
      ? 'flex'
      : 'none';
  }
}
